module.exports = __webpack_public_path__ + "img/insurance.a0c34ce0.svg";